import {
  CountryCodeEnum,
  frenchTaxCountries,
  Mobility,
  workAuthorizationExemptCountries,
} from '@movinmotion/conf-shared';

/**
 * Checks if the selected country is a French tax country.
 * - the default value(empty) is considered a French tax country
 *
 * @param code Tax country code
 */
export const isFrenchTaxCountry = (code: CountryCodeEnum): boolean => !code || frenchTaxCountries.includes(code);

const workAuthorizationExemptCountryCodes = new Set<CountryCodeEnum>(workAuthorizationExemptCountries);

/**
 * Checks if a work authorization has to be provided for the given nationality.
 * - third country nationals have to provide one
 * - EU / EEA / Swiss nationals and French nationals (including DOM-TOM and COM) are exempt
 * - an unknown nationality cannot require anything yet
 *
 * @param nationalityCode Nationality country code, as the apps each hold their own country code type
 */
export const shouldHaveWorkAuthorization = (nationalityCode: string | null | undefined): boolean =>
  !!nationalityCode && !workAuthorizationExemptCountryCodes.has(nationalityCode as CountryCodeEnum);

export function isMobilityEquals(original: Mobility, compared: Mobility): boolean {
  return (
    original.locality === compared.locality &&
    original.postalCode === compared.postalCode &&
    original.region === compared.region &&
    original.countryCode === compared.countryCode
  );
}
